
  var _styles = {
  "crowd-coupon-container": {
    "display": "flex",
    "flexDirection": "column",
    "width": "100%",
    "alignItems": "center"
  },
  "crowd-coupon-title": {
    "fontSize": "0.42667rem",
    "lineHeight": "0.77333rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "600",
    "marginBottom": "0.32rem"
  },
  "prize-list": {
    "width": "100%"
  },
  "single-column": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "double-column": {
    "width": "9.52rem",
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap"
  },
  "triple-column": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "justifyContent": "flex-start",
    "paddingLeft": "0.32rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2', 'url("https://s3.meituan.net/static-prod01/com.sankuai.hoteltripcommon.mktfe.toubleshooting-files/MTfin-Regular3.0.ttf") format("truetype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  